<nav class="navbar">
  <div class="container d-flex align-items-center">
    <div class="cursor-pointer" routerLink="/" (click)="navigate.emit()">
      <img alt="Brand logo" class="navbar-brand img-fluid d-none d-sm-block pe-4" src="">
      <img alt="Brand logo" class="navbar-brand img-fluid d-sm-none pe-4" src="">
    </div>
    <div class="ms-auto d-flex align-items-center gap-3">
      <span
        *ngIf="authenticated && (accountService.account | async) as account"
        class="account-badge"
        [title]="(account.environment === 'sandbox' ? 'Sandbox mode — requests go to carrier test endpoints, not production' : 'Live mode — requests go to carrier production endpoints') + (account.usagePlan ? ' · Plan: ' + account.usagePlan.displayName : '')">
        {{ stripSandboxSuffix(account.displayName) }}
        <span *ngIf="account.environment === 'sandbox'" class="account-badge__tag">Sandbox</span>
      </span>
      <a routerLink="/home" class="nav-icon" title="Home" (click)="navigate.emit()">
        <svg fill="currentColor" width="22" height="22">
          <use href="/assets/icons.svg#icon-home"></use>
        </svg>
      </a>
      <a routerLink="/settings" class="nav-icon" *ngIf="authenticated" title="Settings" (click)="navigate.emit()">
        <svg fill="currentColor" width="22" height="22">
          <use href="/assets/icons.svg#icon-cog"></use>
        </svg>
      </a>
      <button class="nav-icon btn btn-link p-0" [class.authenticated]="authenticated" (click)="changeKey.emit()" title="API Key">
        <svg fill="currentColor" width="22" height="22">
          <use href="/assets/icons.svg#icon-key"></use>
        </svg>
      </button>
    </div>
  </div>
</nav>
